// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"41b4e8e2","920":"e5f970d1"}[chunkId] + ".chunk.js";
};